import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import {
  fetchBookabilityFailure,
  fetchBookabilityStarted,
} from 'redux/actions/availability';

export default function SubmitButton({
  bookability,
  resource,
  passengersCount,
  hideSeats,
}) {
  const { isSubmitting, isValid } = useFormikContext();
  let buttonContent = 'Book now';
  let disabled = false;
  let statusMessage = null;

  if (!bookability) {
    buttonContent = 'Book now';
    disabled = true;
    statusMessage = null;
  } else if (bookability?.fetch === fetchBookabilityStarted.type) {
    buttonContent = (
      <>
        <i className="fas fa-spinner-third animation-momentum-spin me-2" />
        Fetching availability&hellip;
      </>
    );
    disabled = true;
    statusMessage = null;
  } else if (bookability?.fetch === fetchBookabilityFailure.type) {
    buttonContent = 'Unable to fetch availability';
    statusMessage = (
      <div className="text-danger text-small">
        Unable to fetch availability. Please try again.
      </div>
    );
    disabled = true;
    buttonContent = 'Book now';
  } else if (!isValid) {
    statusMessage = null;
    buttonContent = 'Book now';
    disabled = true;
  } else if (!bookability?.available) {
    disabled = true;
    buttonContent = 'Book now';

    const availableCount =
      bookability?.availability_details?.available_capacity || 0;

    if (
      resource.minimum_passengers &&
      passengersCount < resource.minimum_passengers
    ) {
      statusMessage = (
        <div className="text-danger text-x-small">
          {bookability?.error_message}
        </div>
      );
    } else if (hideSeats) {
      statusMessage = (
        <div className="text-danger text-x-small">
          Your requested numbers of seats is not available. Please adjust your
          booking or try an alternative date/time.
        </div>
      );
    } else {
      statusMessage = (
        <div className="text-danger text-x-small">
          {` We only have ${pluralize(
            'seat',
            availableCount,
            true
          )} available. Please adjust your booking or try an alternate date/time.`}
        </div>
      );
    }
  } else if (isSubmitting) {
    buttonContent = (
      <>
        <i className="fas fa-spinner-third animation-momentum-spin me-2" />
        Adding to cart
      </>
    );
    disabled = true;
    statusMessage = null;
  }

  return (
    <>
      {statusMessage}
      <button
        type="submit"
        disabled={disabled}
        className="btn btn-primary w-100"
        data-testid="booking-submit"
      >
        {buttonContent}
      </button>
    </>
  );
}

SubmitButton.propTypes = {
  bookability: PropTypes.shape({
    fetch: PropTypes.string,
    available: PropTypes.bool,
    availability_details: PropTypes.shape({
      available_capacity: PropTypes.number,
    }),
    error_message: PropTypes.string,
  }),
  resource: PropTypes.shape({
    minimum_passengers: PropTypes.number,
    maximum_passengers: PropTypes.number,
  }),
  passengersCount: PropTypes.number,
  hideSeats: PropTypes.bool,
};
